export default __webpack_public_path__ + "static/media/avatar-blur-02.6b091e85.png";